module.exports = __webpack_public_path__ + "static/icloud_1-0f0f6758a30deb438f37b290ce6d6ccb.png";